<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/training-videos"></back-button>
            &nbsp; Upload Training Video
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Training Video</li>
            <li class="active">Upload Training Video</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                &nbsp;&nbsp;
                <a
                  :href="`${mediaUrl}samples/training-video-data.xlsx`"
                  target="_blank"
                >
                  [ Download Sample Excel ]
                </a>

                <input
                  type="file"
                  id="file"
                  name="file"
                  ref="file"
                  accept="application/ms-excel"
                  multiple
                />
                <br />
                <a href="javascript:void" @click="truncatePendingDocuments"
                  >Truncate List</a
                >
                <br /><br />
                <span style="color: red"> {{ message }} </span>
                <span v-if="isLoading"> Uploading...</span>

                <div class="form-footer" v-if="courses.length == 0">
                  <button
                    class="btn btn-primary btn-block"
                    @click="handleFileUpload"
                  >
                    Upload file
                  </button>
                </div>

                <div class="form-footer" v-else>
                  <button
                    class="btn btn-success btn-block"
                    @click="processFile"
                  >
                    Process file
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>COURSE NAME</th>
                        <th>COURSE DESCRIPTION</th>
                        <th>COURSE INSTRUCTOR</th>
                        <th>COURSE NO OF HRS</th>
                        <th>VIDEO TITLE</th>
                        <th>VIDEO DECRIPTION</th>
                        <th>VIDEO NO OF HRS</th>
                        <th>VIDEO LINK</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="2"
                      ></loading-table>
                      <tr v-for="(course, at) in courses" :key="`course${at}`">
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ course.course_name }}</td>
                        <td>{{ course.course_description }}</td>
                        <td>{{ course.course_instructor }}</td>
                        <td>{{ course.course_no_of_hrs }}</td>
                        <td>{{ course.title }}</td>
                        <td>{{ course.description }}</td>
                        <td>{{ course.no_of_hrs }}</td>
                        <td>{{ course.videolink }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "uploadValueLists",
  data() {
    return {
      courses: [],
      message: "",
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let courses = await axios.get(`/crude_courses`);
      this.courses = courses.data.data;
      // console.log(this.courses);
      this.count = courses.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.isLoading = true;
      this.ValueLists = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("coursesData", this.ValueLists);
      await axios
        .post("upload_course", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.courses = response.data.data;
          this.isLoading = false;
          alert("Uploaded Successfully");
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      this.isLoading = false;
    },
    async processFile() {
      try {
        this.isLoading = true;
        await axios.get("process_course");
        alert("Processed Successfully");
        await axios.get("truncate_courses");
        this.courses = [];
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      await axios.get("truncate_courses");
      alert("Truncated Successfully");
      this.courses = [];
    },
  },
};
</script>
